import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import VueFormWizard from 'vue-form-wizard';
// customised bootstrap 4
import './styles/app.scss';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import 'leaflet/dist/leaflet.css';

import * as VueGoogleMaps from 'vue2-google-maps';
import moment from 'moment';

// vue-auth
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAuth from '@websanova/vue-auth/dist/v2/vue-auth.esm.js';
import VueAuthHttp from '@websanova/vue-auth/dist/drivers/http/axios.1.x.js';
import VueAuthRouter from '@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js';

import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import { LControl, LControlLayers, LMap, LMarker, LPopup, LTileLayer } from 'vue2-leaflet';
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
// dropzone
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

// v-switch-case
import VSwitch from 'v-switch-case';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faBoxesStacked, faFlag, faListCheck, faSitemap } from '@fortawesome/free-solid-svg-icons';
import { Entities } from '@/api';

Vue.component('v-map', LMap);
Vue.component('v-tilelayer', LTileLayer);
Vue.component('v-marker', LMarker);
Vue.component('v-marker-cluster', Vue2LeafletMarkercluster);
Vue.component('v-popup', LPopup);
Vue.component('v-control-layers', LControlLayers);
Vue.component('v-control', LControl);

Vue.use(VueFormWizard);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VSwitch);

Vue.filter('shortDate', (date: string): string => {
	if (!date) {
		return '';
	}
	return moment
		.utc(date)
		.local()
		.format('Do MMMM YYYY');
});
Vue.filter('longDateTime', (date: string | number): string => {
	if (date == null) {
		return '';
	}
	return moment
		.utc(date)
		.local()
		.format('h:mma dddd Do MMMM YYYY');
});

Vue.filter('shortDateTime', (date: string): string => {
	if (!date) {
		return '';
	}
	return moment
		.utc(date)
		.local()
		.format('h:mma D-MM-YY');
});

Vue.filter('shortTime', (date: string): string => {
	if (!date) {
		return '';
	}
	return moment
		.utc(date)
		.local()
		.format('h:mma');
});

Vue.filter('dateTimeDiff', (date: string | number): string => {
	if (!date) {
		return '';
	}
	return moment
		.utc(date)
		.local()
		.fromNow(); // format('h:mma D-MM-YY');
});

Vue.filter('roundFloat', (num: number): number | string => {
	if (num === 0) {
		return 0;
	}
	if (!num) {
		return '';
	}
	return Number(num.toFixed(0));
});

Vue.filter('numeric', (number?: number | string): string => {
	return number?.toLocaleString() ?? '';
});

Vue.filter('keyToText', (text: string): string => {
	if (!text) {
		return 'Unknown';
	}
	const separator = ' ';
	const out = text
		.replace(/_/, ' ')
		.replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2');
	return out.charAt(0).toUpperCase() + out.slice(1);
});

Vue.filter('entityName', (entity: Entities): string => {
	if (!entity) {
		return '';
	}
	switch (entity) {
		case Entities.Vats:
			return 'Vat';
		case Entities.Tanks:
			return 'Tank';
		case Entities.WaterMeters:
			return 'Supply';
		case Entities.WaterTanks:
			return 'Storage';
		case Entities.WaterMonitors:
			return 'Usage';
		case Entities.FeedTanks:
			return 'Feed Tank';
	}
});

Vue.filter('decamelize', (text: string): string => {
	if (!text) {
		return 'not subscribed';
	}
	const separator = ' ';
	return text
		.replace(/([a-z\d])([A-Z])/g, '$1' + separator + '$2')
		.replace(/([A-Z]+)([A-Z][a-z\d]+)/g, '$1' + separator + '$2')
		.replace('sms', 'text')
		.toLowerCase();
});

Vue.filter('capitalise', (text: string): string => {
	return text != null
		? text
				.toString()
				.split(' ')
				.map(t => t.charAt(0).toUpperCase() + t.slice(1))
				.join(' ')
		: '';
});

Vue.filter('striphtml', (value: string) => {
	const div = document.createElement('div');
	div.innerHTML = value;
	return div.textContent || div.innerText || '';
});

Vue.filter('milkRating', (score: number): string => {
	if (score === 0) {
		return 'No Risk';
	}
	if (score === 1) {
		return 'Low Risk';
	}
	if (score === 2) {
		return 'Medium Risk';
	}
	if (score === 3) {
		return 'High Risk';
	}
	if (score === 4) {
		return 'Critical Risk';
	}
	return '';
});

Vue.filter('titleCase', (value?: string): string => {
	if (!value) {
		return '';
	}
	return Vue.filter('capitalise')(Vue.filter('decamelize')(value));
});

Vue.filter('pretty', (value: Object): string => {
	return JSON.stringify(value, null, 4);
});

Vue.filter('tonnes', (value?: number | null): string => {
	return value == null
		? 'Unknown Weight'
		: Math.abs(value) >= 1000
		? (value * 0.001).toFixed(1) + ' t'
		: value.toFixed(0) + ' kg';
});

// <script src="https://maps.googleapis.com/maps/api/js?key=<%= VUE_APP_GOOGLE_MAPS_API_KEY %>&libraries=places"></script>
Vue.use(VueGoogleMaps, {
	load: {
		key1: '<%= VUE_APP_GOOGLE_MAPS_API_KEY %>',
		// key: 'AIzaSyCfYjkfmIcxNsv18SVgG_BnTZyblPc45aY',
		key: 'AIzaSyD3r35Y58nE1WXEZxZaW7_i40EvB7JqIbE',
		libraries: 'places', // This is required if you use the Autocomplete plugin
		region: 'NZ', // set region to NZ
		// OR: libraries: 'places,drawing'
		// OR: libraries: 'places,drawing,visualization'
	},
});

library.add(faSitemap, faListCheck, faFlag, faBoxesStacked);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

// Vue Auth Config
Vue.use(VueAxios, axios);
// Vue.axios.defaults.baseURL = 'http://127.0.0.1/api';
// Vue.axios.defaults.baseURL = 'https://api.uat.milk.levno.com/api';
// Vue.axios.defaults.baseURL = 'https://api.milk.levno.com/api';
Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.router = router;

// Vue Auth
Vue.use(VueAuth, {
	plugins: {
		http: Vue.axios,
		router: Vue.router,
	},
	drivers: {
		auth: {
			request(req, token) {
				req.headers.Authorization = 'Bearer ' + token;
			},
			response(res) {
				if (res.data.token) {
					return res.data.token;
				}
			},
		},
		http: VueAuthHttp,
		router: VueAuthRouter,
	},
	options: {
		loginData: { redirect: '' }, // This removes the default vue-auth login redirect. (causes navigation duplicated error)
		authRedirect: { name: 'auth.login', path: '/auth/login' },
		logoutData: { redirect: '/auth/login' },
		// forbiddenRedirect: { name: 'auth.login', path: '/auth/login' },
		notFoundRedirect: { name: 'auth.login', path: '/auth/login' },
	},
});

new Vue({
	router,
	render: h => h(App),
}).$mount('#app');
